import { render, staticRenderFns } from "./ViewList.vue?vue&type=template&id=3fdeb868&scoped=true"
import script from "./ViewList.vue?vue&type=script&lang=js"
export * from "./ViewList.vue?vue&type=script&lang=js"
import style0 from "./ViewList.vue?vue&type=style&index=0&id=3fdeb868&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fdeb868",
  null
  
)

export default component.exports